export default __webpack_public_path__ + "static/media/044-whisk.2886c38b.svg";